/* @bend-expect quartz-no-create-browser-history */
import { createBrowserHistory } from 'history';
import _startCase from 'hs-lodash/startCase';
import { getFullUrl } from 'hubspot-url-utils';
import Raven from 'raven-js';
import { getBaseUrl } from './urls';
export const isAcceptanceTest = window.navigator.webdriver;
export const isDev = process.env.NODE_ENV === 'development';
export const isAcceptanceTestOrDev = isAcceptanceTest || isDev;
export const history = createBrowserHistory({
  basename: getBaseUrl()
});
export const isApiHasMorePages = ({
  hasMore,
  offset,
  currentOffset
}) => {
  if (hasMore === false) return false;
  if (hasMore && offset && currentOffset && offset > currentOffset) return false;
  return true;
};
export function parseStringifiedObject(object) {
  if (typeof object === 'string') {
    try {
      return JSON.parse(object);
    } catch (_unused) {
      return {};
    }
  }
  return object;
}
export const prettifyAppName = name => _startCase(name);
export const getHostApiUrl = () => {
  try {
    const overrideUrl = localStorage.getItem('in-meeting-experience-ui-components-host-url');
    if (overrideUrl) {
      return `https://${overrideUrl}`;
    }
  } catch (e) {
    if (!isAcceptanceTestOrDev) Raven.captureMessage(JSON.stringify(e));else console.error(e);
  }
  return getFullUrl('app-api');
};
export const getProxyApiUrl = () => `${getHostApiUrl()}/embedded-view-auth/proxy`;
export const getInMeetingExperienceProxyApiUrl = () => `${getProxyApiUrl()}/in-meeting-experience-proxy`;
export const isStorybook = window.location.href.includes('storybook');